export enum MODALTYPE {
  QuotesModal = 'QuotesModal',
  OrdersModal = 'OrdersModal',
  SavedCartsModal = 'SavedCartsModal',
  ListsModal = 'ListsModal',
}
